module.exports = "/images/wechat.jpg";